import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BaseService} from '../base/service.base';
import {postContentHeaders} from '../common/headers';
import {Router} from '@angular/router';
import 'rxjs/add/operator/map';
import {User} from '../models/user.model';

@Injectable()
export class AuthenticationService extends BaseService {
  public token: string;
  public user: User;

  constructor(private http: Http, private router: Router) {
    super();
    this.token = localStorage.getItem('id_token');
    const localUserProfile = localStorage.getItem('user');
    if (localUserProfile) {
      this.user = JSON.parse(localUserProfile);
    }
  }

  public login(username, password): Observable<any> {
    const body = JSON.stringify({email: username, password: password});
    const shareable = this.http.post(`${this.baseUrl}/auth`, body, {headers: postContentHeaders})
      .map(response => response.json()).share();
    shareable.subscribe(result => {
      // login successful if there's a jwt token in the response
      const token = result.token;
      const user = result.user;

      if (token) {
        // store username and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('id_token', token);
        localStorage.setItem('user', JSON.stringify(user));

        // set token property after local storage
        this.token = token;

        if (user) {
          this.user = user;
        }
        // return true to indicate successful login
      }
    }, error => {
      console.log('Login ongeldig');
    });

    return shareable;
  }

  public logout(): void {
    // clear token remove user from local storage to log user out
    this.token = null;
    this.user = null;
    localStorage.removeItem('id_token');
    localStorage.removeItem('user');

    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts